import { useSelector } from "react-redux";
import { Link } from 'react-router-dom';
import './CaseStudy.css';
import Navbar from '../../Common/Navbar/Navbar';
import Footer from '../../Common/Footer/Footer';

import CaseStudies from "../../Services/CaseStudiesData";
import CaseStudyCard from "./CaseStudyCard";


function Gallery() {
    const isDark = useSelector(state => state.functionslice.value.isDark);

    return (
        <>
            <Navbar />
            <div className={`gallery-page ${isDark ? 'dark-theme' : ''}`}>
                <section className="gallery-hero">
                    <div className="gallery-hero-content">
                        <h1>Success Stories</h1>
                        <p>Showcasing our partnerships, installations, and real-world impact in smart mobility solutions across cities worldwide.</p>
                    </div>
                </section>
     
                <section className="gallery-success-stories">
                    {CaseStudies.map((study, index) => (
                        <CaseStudyCard key={study.url} study={study} index={index} />
                    ))}
                </section>
  
                <section className="gallery-cta-section">
                    <div className="gallery-cta-content">
                        <h2>Ready to Transform Your City?</h2>
                        <p>Join the growing network of cities leveraging Parimitra's AI-powered mobility solutions for smarter, safer transportation.</p>
                        <Link to="/contact">
                            <button className="gallery-btn-cta">Start Your Journey</button>
                        </Link>
                    </div>
                </section>
            </div>
            <Footer />
        </>
    );
}

export default Gallery;
